import { render, staticRenderFns } from "./RequestedUser.vue?vue&type=template&id=2283a641&scoped=true&"
import script from "./RequestedUser.vue?vue&type=script&lang=js&"
export * from "./RequestedUser.vue?vue&type=script&lang=js&"
import style0 from "./RequestedUser.vue?vue&type=style&index=0&id=2283a641&prod&scoped=true&lang=css&"
import style1 from "./RequestedUser.vue?vue&type=style&index=1&id=2283a641&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2283a641",
  null
  
)

export default component.exports